export default "__VITE_ASSET__B6_n2ifH__"